import { render, staticRenderFns } from "./CustomDatabaseListViewComponent.vue?vue&type=template&id=66d56b43&scoped=true"
import script from "./CustomDatabaseListViewComponent.vue?vue&type=script&lang=js"
export * from "./CustomDatabaseListViewComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomDatabaseListViewComponent.vue?vue&type=style&index=0&id=66d56b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d56b43",
  null
  
)

export default component.exports